
import { Link } from 'react-router-dom';
import PromoCountdown from './PromoCountdown';

export default function PromoHero() {
  const saleEndDate = new Date();
  saleEndDate.setDate(saleEndDate.getDate() + 3);
  saleEndDate.setHours(23, 59, 59, 999);

  return (
    <section className="relative min-h-[600px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4b05f4036509c1fb092d4f02bc398b73.jpg"
          alt="Promo Deals Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/70 to-slate-950/90"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-32 w-full text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/30 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-flashlight-line text-amber-400 w-4 h-4 flex items-center justify-center"></i>
          <span className="text-amber-300 text-sm font-semibold uppercase tracking-wider">Flash Sale — Limited Time</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white font-display mb-6 leading-tight">
          Massive Savings for<br />
          <span className="bg-gradient-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent">Australian Tradies</span>
        </h1>

        <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-10">
          Up to <strong className="text-white">60% off</strong> annual plans, exclusive bundles, and seasonal promo codes. 
          Don&apos;t miss the biggest MtaPlannerPro sale of the year.
        </p>

        {/* Countdown */}
        <div className="mb-10">
          <PromoCountdown targetDate={saleEndDate} label="Sale Ends In" size="lg" />
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#flash-deals"
            className="px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg font-semibold text-lg hover:shadow-lg hover:shadow-amber-500/30 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-fire-line mr-2"></i>
            View Flash Deals
          </a>
          <a
            href="#bundles"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-lg font-semibold text-lg hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-gift-line mr-2"></i>
            Browse Bundles
          </a>
        </div>

        {/* Trust */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-slate-400 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-emerald-400"></i>
            <span>30-day money-back guarantee</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-lock-line text-amber-400"></i>
            <span>Secure checkout via Stripe</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-timer-line text-red-400"></i>
            <span>Limited availability</span>
          </div>
        </div>
      </div>
    </section>
  );
}
